import type { SVGProps } from 'react'

type IconProps = SVGProps<SVGSVGElement>

const ACCENT = '#FF69B4'
const ACCENT_2 = '#22d3ee'

export function ProposalNewIcon(props: IconProps) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path d="M7 3.5H13.5L18 8V19.5C18 20.3 17.3 21 16.5 21H7C6.2 21 5.5 20.3 5.5 19.5V5C5.5 4.2 6.2 3.5 7 3.5Z" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M13.5 3.5V7.2C13.5 7.6 13.9 8 14.3 8H18" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
      <circle cx="17.5" cy="16.5" r="4" fill={ACCENT} />
      <path d="M17.5 14.9V18.1M15.9 16.5H19.1" stroke="white" strokeWidth="1.4" strokeLinecap="round" />
      <circle cx="8.2" cy="18.2" r="0.9" fill={ACCENT_2} />
    </svg>
  )
}

export function TemplateIcon(props: IconProps) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <rect x="4" y="5" width="12" height="14" rx="2" stroke="currentColor" strokeWidth="1.7" />
      <rect x="8" y="3" width="12" height="14" rx="2" stroke="currentColor" strokeWidth="1.7" opacity="0.75" />
      <path d="M10.5 7H17M10.5 10H17M10.5 13H15" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      <circle cx="18.3" cy="17.8" r="1.1" fill={ACCENT_2} />
    </svg>
  )
}

export function SentIcon(props: IconProps) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path d="M4 11.2L20 4.2L13.2 20L10.6 13.8L4 11.2Z" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round" />
      <path d="M10.6 13.8L20 4.2" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
      <circle cx="5.8" cy="6.2" r="1" fill={ACCENT_2} />
    </svg>
  )
}

export function ViewedIcon(props: IconProps) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path d="M2.8 12C4.9 8.2 8 6.3 12 6.3C16 6.3 19.1 8.2 21.2 12C19.1 15.8 16 17.7 12 17.7C8 17.7 4.9 15.8 2.8 12Z" stroke="currentColor" strokeWidth="1.7" />
      <circle cx="12" cy="12" r="3.2" stroke="currentColor" strokeWidth="1.7" />
      <circle cx="12.8" cy="11.2" r="1.1" fill={ACCENT} />
    </svg>
  )
}

export function SignedIcon(props: IconProps) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <circle cx="12" cy="12" r="8" stroke="currentColor" strokeWidth="1.7" />
      <path d="M8.2 12.2L10.8 14.8L15.9 9.7" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="17.8" cy="7.2" r="1.1" fill={ACCENT_2} />
    </svg>
  )
}

export function FollowupIcon(props: IconProps) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path d="M18.8 10.5C18.8 6.9 15.9 4 12.3 4C9.3 4 6.8 6 6 8.7" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
      <path d="M5.9 6.2V9.2H8.9" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M5.2 13.5C5.2 17.1 8.1 20 11.7 20C14.7 20 17.2 18 18 15.3" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
      <circle cx="18.3" cy="13.8" r="2.6" fill={ACCENT} />
      <path d="M18.3 12.6V14.9M17.15 13.75H19.45" stroke="white" strokeWidth="1.3" strokeLinecap="round" />
    </svg>
  )
}

export function AnalyticsIcon(props: IconProps) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path d="M4 20H20" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
      <rect x="5.5" y="11" width="3" height="7" rx="1" stroke="currentColor" strokeWidth="1.7" />
      <rect x="10.5" y="8" width="3" height="10" rx="1" stroke="currentColor" strokeWidth="1.7" />
      <rect x="15.5" y="5.5" width="3" height="12.5" rx="1" stroke="currentColor" strokeWidth="1.7" />
      <circle cx="17.7" cy="5.2" r="1" fill={ACCENT_2} />
    </svg>
  )
}

export function ClientsIcon(props: IconProps) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <circle cx="9" cy="9" r="3" stroke="currentColor" strokeWidth="1.7" />
      <path d="M3.8 18.7C4.5 15.9 6.5 14.3 9 14.3C11.5 14.3 13.5 15.9 14.2 18.7" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
      <circle cx="16.8" cy="9.3" r="2.6" fill={ACCENT} />
      <path d="M15.7 9.4L16.5 10.2L18.1 8.6" stroke="white" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export function IntegrationsIcon(props: IconProps) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <circle cx="6.5" cy="12" r="2.3" stroke="currentColor" strokeWidth="1.7" />
      <circle cx="17.5" cy="6.8" r="2.3" stroke="currentColor" strokeWidth="1.7" />
      <circle cx="17.5" cy="17.2" r="2.3" stroke="currentColor" strokeWidth="1.7" />
      <path d="M8.7 11L15.2 7.8M8.7 13L15.2 16.2" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
      <circle cx="12.2" cy="12" r="1" fill={ACCENT_2} />
    </svg>
  )
}

export function BillingIcon(props: IconProps) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <rect x="3.5" y="6" width="17" height="12" rx="2.5" stroke="currentColor" strokeWidth="1.7" />
      <path d="M3.5 9.5H20.5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
      <rect x="14.7" y="13.2" width="4.1" height="2.3" rx="1.1" fill={ACCENT} />
      <circle cx="6.3" cy="14.6" r="0.9" fill={ACCENT_2} />
    </svg>
  )
}

export function NotificationsIcon(props: IconProps) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path d="M12 4.2C9.2 4.2 7 6.4 7 9.2V12.3L5.7 14.9C5.4 15.5 5.8 16.2 6.5 16.2H17.5C18.2 16.2 18.6 15.5 18.3 14.9L17 12.3V9.2C17 6.4 14.8 4.2 12 4.2Z" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round" />
      <path d="M10.2 18C10.6 18.8 11.2 19.2 12 19.2C12.8 19.2 13.4 18.8 13.8 18" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
      <circle cx="17.9" cy="6.1" r="2.1" fill={ACCENT} />
      <circle cx="17.9" cy="6.1" r="0.8" fill="white" />
    </svg>
  )
}

export function SignatureIcon(props: IconProps) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path d="M3.5 16.5C6 14.2 7.7 18 10 16.2C11.5 15 12 12.6 13.7 12.6C15.4 12.6 15.6 14.8 17.1 14.8C18.4 14.8 19.1 13.8 20.5 12.8" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      <path d="M3.5 19.5H20.5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
      <circle cx="18.6" cy="7.1" r="3.2" fill={ACCENT} />
      <path d="M17.2 7.2L18.2 8.2L20 6.3" stroke="white" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}
